<template>
  <loading v-model:active="isLoading">
    <div class="loadingio-spinner-ellipsis-rg3crixpxzh">
      <div class="ldio-zmt4lrj3aj">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </loading>
</template>

<script>
export default {
  props: ['is-loading']
}
</script>
